import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdService {
    private adScriptUrl = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3502947872881560'; // Placeholder ID
    // TODO: Replace with your actual Google Analytics Measurement ID (format: G-XXXXXXXXXX)
    private analyticsId = 'G-PLACEHOLDER';
    private adsEnabled = new BehaviorSubject<boolean>(false);
    adsEnabled$ = this.adsEnabled.asObservable();

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            const consent = localStorage.getItem('cookieConsent');
            if (consent === 'accepted') {
                this.enableAds();
                this.enableAnalytics();
            }
        }
    }

    enableAds() {
        if (!isPlatformBrowser(this.platformId) || this.adsEnabled.value) return;

        this.adsEnabled.next(true);

        // Inject script
        const script = document.createElement('script');
        script.async = true;
        script.src = this.adScriptUrl;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);
    }

    setConsent(accepted: boolean) {
        if (isPlatformBrowser(this.platformId)) {
            if (accepted) {
                localStorage.setItem('cookieConsent', 'accepted');
                this.enableAds();
                this.enableAnalytics();
            } else {
                localStorage.setItem('cookieConsent', 'declined');
                // Ideally we would want to remove the script/cookies here if they existed, 
                // but for a simple implementation we just won't load them on next refresh 
                // and won't load them now if not already loaded.
                this.adsEnabled.next(false);
            }
        }
    }

    hasValidConsent(): boolean | null {
        if (isPlatformBrowser(this.platformId)) {
            const val = localStorage.getItem('cookieConsent');
            if (val === 'accepted') return true;
            if (val === 'declined') return false;
        }
        return null; // No choice made yet
    }

    private enableAnalytics() {
        if (!isPlatformBrowser(this.platformId)) return;

        // Check if script is already there
        if (document.getElementById('google-analytics')) return;

        // Inject script
        const script = document.createElement('script');
        script.id = 'google-analytics';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.analyticsId}`;
        document.head.appendChild(script);

        // Configure gtag
        const win = window as any;
        win.dataLayer = win.dataLayer || [];
        function gtag(...args: any[]) { win.dataLayer.push(args); }
        gtag('js', new Date());
        gtag('config', this.analyticsId, { 'anonymize_ip': true });
    }
}
